import React from 'react';

const NotFoundPage = () => {
  return (
    <>
      <div style={{ width: '100%', fontSize: '25px', marginTop: '60px' }}>
        <h1>404 - Not Found</h1>
        <p>ページが見つかりません。</p>
      </div>
    </>
  );
};

export default NotFoundPage;
